import { getFeatureToggle } from "api/services/configService";
import { useQuery } from "@tanstack/react-query";

/**
 * Overloads for clarifying the return type when omitting the default value.
 */
export function useFeatureToggle(
  hqId: string,
  name: string,
  defaultValue: boolean
): boolean;

export function useFeatureToggle(
  hqId: string,
  name: string
): boolean | undefined;

export function useFeatureToggle(
  hqId: string,
  name: string,
  defaultValue?: boolean | undefined
): boolean | undefined {
  const { data } = useQuery(
    ["feature-toggle", hqId, name],
    () => getFeatureToggle(hqId, name),
    {
      enabled: Boolean(hqId)
    }
  );

  return data ?? defaultValue;
}
